import { useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { gql, useQuery, useMutation } from "@apollo/client";
import { ActivityList } from "components/ActivityList";
import { DataContext } from "providers/DataProvider";
import { ALL_PICTURE_FIELDS, ME_QUERY, CHANGE_PROFILE_PIC_MUTATION } from "graphql/APICalls";
import { GroupsDisplay, handleImageUpload } from "components/Helpers";

import 'styles/UserProfile.css';



function ProfileBody({user, isMe}) {

  const { me } = useContext(DataContext);

  const fileInputRef = useRef(null);
  const formRef = useRef(null);

  const [changeProfilePic] = useMutation(CHANGE_PROFILE_PIC_MUTATION);

  const handleProfilePictureClick = () => { fileInputRef.current.click() };

  const handleFileChange = async (event) => {
    if (event.target.files.length > 0) {
        const createdImageId = await handleImageUpload(event.target.files[0]);

        await changeProfilePic({
          variables: {newImageId: createdImageId},
          refetchQueries: [ { query: ME_QUERY } ]
        })
    }
};

  return (
    <div className="auto-scrollbar">
    <div className="centerer user-profile-overlay">
      <div className="centered user-profile">

        <div className="profile-user-card">

          <div className={"profile-image " + (isMe ? "own" : "")} onClick={isMe ? handleProfilePictureClick : (()=>{})}>
            <img src={user?.picture?.imageSrc} alt="user profile pic"/>
            <img className="edit-overlay" src="/edit-icon.svg" alt="edit overlay"/>
            <form ref={formRef} action="/upload" method="POST" style={{ display: 'none' }}>
                <input
                    type="file"
                    name="profilePicture"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                />
            </form>
          </div>

          <div className="profile-user-data">
            <label className="profile-field-value"><b>{user?.name}</b></label>
            <label className="profile-field-value" style={{color: '#444'}}>{user?.username}</label>
            { user?.email && <label className="profile-field-value">{user?.email}</label> }
            <label className="profile-field-value">{user?.bio}</label>
          </div>
        </div>

        {!me.email &&
          <label className="signed-out-notification">
            You are seeing the public version of {user?.name}'s profile since you are not logged in.
          </label>
        }
        
        {me.email &&
          <div className="profile-user-groups">
            <h3>{isMe ? 'Your groups' : 'Groups you share'}</h3>
            <GroupsDisplay groups={user?.groups}/>
          </div>
        }
        
        <div className="profile-user-activities">
          <h3>{isMe ? 'Your' : `${user?.name}'s`} activities</h3>
          <ActivityList activities={user?.activities} hideCreator={true}/>
        </div>
        
        {
          isMe ?
            <div className="profile-user-joins">
              <h3>Bookmarked activities</h3>
              <ActivityList activities={user?.joinRequests ? user.joinRequests.map(joinRequest => joinRequest.activity) : null}/>
            </div>
          : null
        }

      </div>
    </div>
    </div>
  )

}

function OwnProfile() {
  const { me } = useContext(DataContext);
  return <ProfileBody user={me} isMe={true}/>
}


const USER_QUERY = gql`query ($username: String!) {
    getUser(username: $username) {
        id, name, username, email, picture ${ALL_PICTURE_FIELDS}, bio, activities {id, shortId, title, creator {id, name}, location {name}}, groups {id, shortId, name, status}
    }
}`

function OtherUserProfile({username}){
  const userQuery = useQuery(USER_QUERY, {variables: {username}, fetchPolicy: 'network-only'});
  return <ProfileBody user={userQuery.data?.getUser}/>
}

// TODO: display bio on UserProfile
// TODO: consider when and how to display activites that the user is attending

export default function UserProfile(){

  const { username } = useParams();

  /* TODO: If the user goes to their own profile via the /user/{userId} route they should still
           see "your activities" and "your groups" headers */
  return username === undefined ? <OwnProfile/> : <OtherUserProfile username={username}/>

}